export var MuiCardActions = {
  styleOverrides: {
    root: function root(_ref) {
      var theme = _ref.theme;
      return {
        overflow: 'hidden',
        padding: theme.spacing(theme.spaces.main),
        "& .MuiButtonGroup-outlined, & .MuiButton-outlined": {
          width: '100%',
          borderColor: theme.palette.grey[300],
          borderRadius: 0,
          borderLeft: 0,
          borderRight: 0,
          borderBottom: 0,
          "& + .MuiButton-outlined, & + .MuiButton-outlined:hover": {
            borderLeft: "1px solid ".concat(theme.palette.grey[300])
          },
          "&:hover": {
            borderLeft: 0,
            borderRight: 0,
            borderBottom: 0,
            borderColor: theme.palette.grey[300]
          }
        }
      };
    }
  }
};
//# sourceMappingURL=MuiCardActions.js.map